<template>
    <train-home></train-home>
</template>
<style>

</style>
<script>
    import trainHomepage from "trainHomepage";
    export default{
        data(){
            return{

            }
        },
        components:{

        }
    }
</script>



// WEBPACK FOOTER //
// src/views/train/home/home.vue